import React from 'react';
import PieChart, { Series } from 'devextreme-react/pie-chart';
import '../../scss/controls/_progressdonut.scss';

// The color for the progress arc (the filled portion of the donut)
export enum ProgressColor {
  Orange = '#FFA000',
  Yellow = '#FFF149',
  Green = '#2E7D32',
  Blue = '#1976D2',
  Purple = '#8E44AD',
  Red = '#FF0808',
}

// The color of the unfilled portion of the ring
export enum BackgroundColor {
  Grey = '#E9E9E9',
  White = '#FFFFFF',
  Black = '#000000',
}

interface ProgressDonutProps {
    // A value between 0 and 100 representing the progress percentage
    value: number;
    // The overall size (width and height) of the donut in pixels
    size?: number;
    progressColor?: ProgressColor;
    backgroundColor?: BackgroundColor;
}

// The ratio of the diameter of the inner circle to that of the pie chart
const ringWidth = 0.7;

export const ProgressDonut: React.FC<ProgressDonutProps> = ({ value, size = 100, progressColor = ProgressColor.Blue, backgroundColor = BackgroundColor.Grey }) => {
    // We use two data slices: one for progress, one for the remainder.
    const dataSource = [
        { category: 'Progress', value: value },
        { category: 'Remaining', value: 100 - value },
    ];

    // Setting CSS variables to pass dynamic values to our SCSS file
    const containerStyle: React.CSSProperties = {
        '--donut-size': `${size}px`,
        '--center-size': `${size * ringWidth}px`,
        '--progress-color': progressColor,
        '--background-color': backgroundColor,
    } as React.CSSProperties;

    return (
        <div
            // Outer container
            className='progress-donut-container'
            style={containerStyle}
        >
            {/* PieChart used as a donut chart */}
            <PieChart
                id='progress-donut-chart'
                width={size}
                height={size}
                dataSource={dataSource}
                palette={[progressColor, backgroundColor]}
                innerRadius={10}
                startAngle={90}
                resolveLabelOverlapping='none'
                title=''
                legend={{ visible: false }}
                export={{ enabled: false }}
            >
                <Series
                    argumentField='category'
                    valueField='value'
                />
            </PieChart>
            {/* Center overlay: a white circle containing percentage text */}
            <div className='progress-donut-center'>{value}%</div>
        </div>
    );
};
